import { Form, message, Modal, Select, Button, Flex } from 'antd';
import { FC } from 'react';
import { TransferRow } from './TransfersPage';
import { useInitiateTransferWithdrawalStage } from './useInitiateTransferWithdrawalStage';

export const InitiateTransferWithdrawalStageModal: FC<{ transfer: TransferRow; onClose: () => void }> = ({
  transfer,
  onClose,
}) => {
  const [messageApi, contextHolder] = message.useMessage();

  const { initiateTransferWithdrawalStage, isInitiatingTransferWithdrawalStage } = useInitiateTransferWithdrawalStage();

  const [form] = Form.useForm();

  const onFinish = () => {
    initiateTransferWithdrawalStage({
      transfer_id: transfer.id,
      transfer_type: transfer.type,
    })
      .then(() => {
        messageApi.success('Successfully initiated!');
        onClose();
      })
      .catch(() => {
        messageApi.error('Something is wrong');
      });
  };

  return (
    <Modal
      loading={isInitiatingTransferWithdrawalStage}
      title="Initiate Transfer Withdrawal Stage"
      destroyOnClose
      footer={null}
      open
      onCancel={onClose}
    >
      {contextHolder}
      <Form
        onFinish={onFinish}
        name="initiateTransferWithdrawalStageModal"
        form={form}
        requiredMark={false}
        style={{
          paddingTop: 20,
        }}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item
          rules={[
            {
              required: true,
              message: 'Please select',
            },
          ]}
          name="withdrawal_transaction_source_network"
          layout="vertical"
          label="Offramp withdrawal transaction source network"
        >
          <Select placeholder="Select value...">
            <Select.Option value="individual">Solana</Select.Option>
            <Select.Option value="corporate">Base</Select.Option>
          </Select>
        </Form.Item>

        <Flex style={{ paddingTop: '18px' }} gap={'middle'} justify="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Initiate Withdrawal
          </Button>
        </Flex>
      </Form>
    </Modal>
  );
};
